import { useNavigate } from 'react-router-dom';
import PrivateTitle from "./PrivateTitle";
import EventDetails from "./EventDetails";
import BePrivateButton from "./BePrivateButton";
import DownBar from "./DownBar";
import backgroundVideo from "../assets/background_video.mp4";
import "../styles/global.css";

function MainEventPage() {

  const navigate = useNavigate();
  const eventInfo = {
    title: "WHITE BALADI",
    date: "JUNE 2ⁿᵈ AT 6PM",
    description: "DRESS CODE: WHITE",
    location: "LOCATION WILL BE ANNOUNCED ON THE DAY OF THE EVENT*"
  };
  const navigateToOrder = () => {
    navigate("/order");
  };

  const navigateToSummitPay = () => {
    window.location.href = "https://pay.sumit.co.il/e44cix/ejzpym/ejzpys/payment/";
  };

  return (
    <div className="main-container">
        <video
            className="background-video"
            src={backgroundVideo}
            autoPlay
            loop
            muted
            playsInline
        />
        <div className="content">
            <PrivateTitle />
            <EventDetails
              title={eventInfo.title}
              description={eventInfo.description}
              date={eventInfo.date}
              location={eventInfo.location}
            ></EventDetails>
            <BePrivateButton text="BE PRIVATE" callback={navigateToSummitPay}/>
        </div>
        <div className="buttom-page">
          <DownBar />
        </div>
        
    </div>
);
}
export default MainEventPage;
